module.exports = __webpack_public_path__ + "static/media/Human_ZG3243_360.eb778147.jpeg";